// extracted by mini-css-extract-plugin
export default {"textAnnotationSettings":"TextAnnotationSettings_textAnnotationSettings__KXoZO"};